import jss from 'jss'
import preset from 'jss-preset-default'
import {generateVectorPosition} from 'Client/utils/vector-position'

class WidgetECFListPeople extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            // Tạo variables class cần DOM trong widget
            selectors: {
                app: '#ecf-list-people',
                list: '.box-list-people',
                seeMore: '.ecf-see-more-btn-with-behavior'
            },
        };
    }

    getDefaultElements() {
        const selectors = this.getSettings( 'selectors' );
        return {
            // Tạo variables DOM trong widget
            $app: this.$element.find( selectors.app ),
            $list: this.$element.find( selectors.list ),
            $seeMore: this.$element.find( selectors.seeMore ),
        };
    }

    convertHTMLArrayToPrototypeArray(classDOM,classParent){
        let convertString = classDOM.toString();
        let DOM = classParent.querySelectorAll(convertString);
        return Array.prototype.slice.call(DOM)
    }

    getDataObject(element){
        if( typeof element !== 'undefined'){
            return JSON.parse(atob(element.getAttribute('data-introduce')))
        }else{
            return {}
        }
    }

    initStyle(modal){
        jss.setup(preset())
        const styles = {
            modal:{
                display: 'block',
                position: 'fixed',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                zIndex: 10000,
                overflowY: 'auto',
                background: 'rgba(234,237,245,0.8)',
                '@media screen and (max-height: 650px)': {
                    padding: ['16px',0]
                },
                '@media screen and (max-width: 560px)': {
                    overflowY: 'scroll',
                    padding: ['16px',0]
                },
                '& .lightbox-container': {
                    position: 'relative',
                    zIndex: 2,
                    height: '100%',
                    '@media screen and (max-width: 560px)': {
                        alignItems: 'flex-start !important',
                        height: 'unset',
                    },
                },
                '&  .ecf-lightbox__bg':{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    opacity: 0.8,
                    zIndex: 1,
                },
                '& .ecf-lightbox__container': {
                    background: '#FFFFFF',
                    mixBlendMode: 'normal',
                    boxShadow: [0, 0, '16px', '#EAEDF5'],
                    borderRadius: '16px',
                    position: 'relative',
                    padding: [79,76,81,76],
                    '@media screen and (max-width: 560px)':{
                        padding: [30,15,30,15]
                    },
                    zIndex: 2,
                    '& .ecf-lightbox__close': {
                        position: 'absolute',
                        top: 19,
                        right: 26,
                        zIndex: 20,
                        cursor: 'pointer',
                        '& i': {
                            fontSize: 32,
                        }
                    },
                    '& .ecf-lightbox__content' :{
                        '& .row' :{
                            '@media screen and (max-width: 560px)': {
                                display: 'block',
                            }
                        },
                        '& img' : {
                            width: 120,
                            height: 120,
                            objectFit: 'contain',
                            objectPosition : 'center',
                            marginBottom: '44px',
                            borderRadius: '50%',
                        },
                        '& .name':{
                            fontWeight: 600,
                            fontSize: 16,
                            lineHeight: '24px',
                        },
                        '& .position' : {
                            marginTop: 8,
                            fontWeight: 500,
                            fontSize: 14,
                            lineHeight: '20px',
                            '@media screen and (max-width: 992px)':{
                                marginBottom: 24,
                            },
                        },
                        '& .introduce': {
                            '& p, & li, & a': {
                                fontWeight: 300,
                                fontSize: 16,
                                lineHeight: '24px',
                                '@media screen and (max-width: 560px)':{
                                    fontSize: 14,
                                    lineHeight: '20px',
                                },
                            },
                            '& p': {
                                marginBottom: 24,
                                '&:last-child':{
                                    marginBottom: 0,
                                },
                            }
                        },
                        '& svg':{
                            '@media screen and (max-width: 992px)' :{
                                display: 'none',
                            }
                        }
                    }
                }
            }
        }
        const {classes} = jss.createStyleSheet(styles).attach()
        modal.classList.add(classes.modal)
    }

    renderModalHTML(data){
        let { name, img,introduce,position} = data
        let imURL = typeof img.url !== 'undefined' ? img.url : ''  ;
        return `
            <div class="ecf-lightbox justify-content-center align-items-center">
                <div class="ecf-lightbox__bg"></div>
                <div class="d-flex container justify-content-center align-items-center lightbox-container">
                     <div class="ecf-lightbox__bg"></div>
                     <div class="ecf-lightbox__container col-12 col-md-10">
                        <div class="ecf-lightbox__close">
                            <i class="fal fa-times"></i>
                        </div>
                        <div class="ecf-lightbox__content">
                            <div class="row">
                                <div class="col-12 col-lg-3">
                                    <img src="${imURL}" alt="people-member" /> 
                                    <p class="name">${name}</p>
                                    <p class="position">${position}</p>
                                </div>
                                 <div class="col-12 col-lg-1">
                                    <div class="bg-line"></div>
                                 </div>
                                 <div class="col-12 col-lg-8">
                                    <div class="introduce ecf-content ecf-content-normal">
                                        ${introduce}
                                    </div>
                                 </div>
                            </div>
                        </div>
                     </div>
                </div>
                </div>
            </div>
        `
    }

    createModal(data,THIS){
        let modal = document.querySelector('.ecf-lightbox')
        let body = document.querySelector('body')
        let html = document.querySelector('html')
        modal && modal.remove()
        const MODAL_HTML = THIS.renderModalHTML(data)
        html.classList.add('active')
        body.insertAdjacentHTML('beforeend',MODAL_HTML)
        modal = document.querySelector('.ecf-lightbox')
        THIS.initStyle(modal)
    }

    closeModal(){
        let modal = document.querySelector('.ecf-lightbox')
        let html = document.querySelector('html')
        let closeBTN  = document.querySelector('.ecf-lightbox .ecf-lightbox__close')
        let closeBG = document.querySelectorAll('.ecf-lightbox .ecf-lightbox__bg')
        closeBTN && closeBTN.addEventListener('click', () =>{
            html.classList.remove('active')
            modal && modal.remove()
        })
        closeBG.length>0 && closeBG.forEach(item=>{
            item.addEventListener('click', () =>{
                html.classList.remove('active')
                modal && modal.remove()
            })
        })
    }

    handShowPopup(data,THIS){
        THIS.createModal(data,THIS)
        THIS.closeModal()
    }

    bindEvents() {
        const THIS = this;
        const ELEMENT = this.elements.$app[0];
        const LIST = this.elements.$list[0];
        const SEEMORE = this.elements.$seeMore[0]
        /* Image decoration handle */
        if(ELEMENT) {
            let imgs = Array.prototype.slice.call(ELEMENT.querySelectorAll('picture img'));
            imgs.forEach(element => {
                let dataPosition = element.getAttribute('data-position');
                let dataResponsive = element.getAttribute('data-responsive');
                let defaultObj = JSON.parse(atob(dataPosition))
                let responsive = JSON.parse(atob(dataResponsive))
                generateVectorPosition(defaultObj, responsive, element);
            });
        }
        /* ReadMore button handle*/
        if(LIST){
            let listMembers = THIS.convertHTMLArrayToPrototypeArray('.item-people',LIST)
            for(const[index,member] of listMembers.entries()){
                member.addEventListener('click',()=>{
                    let buttonRD = member.querySelector('.ecf-link')
                    let data = THIS.getDataObject(member)
                    buttonRD && THIS.handShowPopup(data,THIS)
                })
            }
        }
        /* Handle See More Click*/
        if(SEEMORE){
            SEEMORE.addEventListener('click',()=>{
                let listMembers = THIS.convertHTMLArrayToPrototypeArray('.item-people',LIST)
                for(const[index,member] of listMembers.entries()){
                   if(!member.classList.contains('active--mb')){
                       let parentMem = member.parentElement
                       parentMem.classList.remove('unactive--mb');
                   }
                }
                SEEMORE.remove()
            })
        }
    }
}

jQuery( window ).on( 'elementor/frontend/init', () => {
    const addHandler = ( $element ) => {
        elementorFrontend.elementsHandler.addHandler( WidgetECFListPeople, {
            $element,
        } );
    };
    // efc_form_donate ->Name widget register in php
    elementorFrontend.hooks.addAction( 'frontend/element_ready/ecf_list_people.default', addHandler );
} );

